import { Link } from 'react-router-dom';
import { channels } from '../../test.data';
import Container from '../containers/container';
import Avatar from '../images/avatar';
import { HStack, VStack } from '../layouts/stack.layout';
import Heading from '../typography/v2/heading';
import Text from '../typography/v2/text';

const styles = {
  container: 'h-[300px] relative overflow-auto px-2.5',
  'text-container':
    'tablet-lg:hidden desktop:block sticky top-0 bg-[#08080D] z-20 py-1.5',
};

export default function FavouriteChannels() {
  const favouriteChannels = channels.filter(
    ({ hasJoined, favourite }) => hasJoined === true && favourite === true
  );
  return (
    <VStack gap="base" extensions={styles.container}>
      <Container extensions={styles['text-container']}>
        <Heading variant="secondary">Favourite Channels</Heading>
      </Container>
      <VStack gap="sm">
        {favouriteChannels.map(({ backgroundImage, id, title }) => (
          <Link key={`avatar-${id}`} to={`/channels/${id}`}>
            <HStack gap="sm" extensions="items-center">
              {backgroundImage && id && title && (
                <>
                  <Avatar alt={title} url={backgroundImage} size="xs" />
                  <Container extensions="mobile:hidden desktop:block">
                    <Text>{title}</Text>
                  </Container>
                </>
              )}
            </HStack>
          </Link>
        ))}
      </VStack>
    </VStack>
  );
}
